import { useState, useEffect } from 'react';
import { eventInfo } from '../../data/landingData';

export const Countdown = () => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  function calculateTimeLeft() {
    const difference = eventInfo.eventDate - new Date();
    
    if (difference <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / (1000 * 60)) % 60),
      seconds: Math.floor((difference / 1000) % 60)
    };
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const TimeBlock = ({ value, label }) => (
    <div className="text-center">
      <div className="relative">
        <div className="bg-[#111111] border border-white/10 rounded-lg px-4 py-3 min-w-[70px] md:min-w-[90px]">
          <span 
            className="text-3xl md:text-4xl font-manrope font-bold text-[#D4AF37] tabular-nums"
            key={value}
          >
            {String(value).padStart(2, '0')}
          </span>
        </div>
      </div>
      <span className="text-xs md:text-sm text-zinc-500 font-manrope uppercase tracking-widest mt-2 block">
        {label}
      </span>
    </div>
  );

  return (
    <div 
      className="inline-flex items-center gap-2 md:gap-4"
      data-testid="countdown-timer"
    >
      <TimeBlock value={timeLeft.days} label="Days" />
      <span className="text-2xl text-[#D4AF37] font-light mb-6">:</span>
      <TimeBlock value={timeLeft.hours} label="Hours" />
      <span className="text-2xl text-[#D4AF37] font-light mb-6">:</span>
      <TimeBlock value={timeLeft.minutes} label="Mins" />
      <span className="text-2xl text-[#D4AF37] font-light mb-6 hidden md:block">:</span>
      <div className="hidden md:block">
        <TimeBlock value={timeLeft.seconds} label="Secs" />
      </div>
    </div>
  );
};

export const SpotsRemaining = ({ spots = eventInfo.spotsRemaining, total = eventInfo.totalSpots }) => {
  const percentage = ((total - spots) / total) * 100;
  
  return (
    <div 
      className="glass rounded-full px-6 py-3 inline-flex items-center gap-3"
      data-testid="spots-remaining"
    >
      {/* Pulsing indicator */}
      <div className="relative">
        <div className="w-3 h-3 bg-red-500 rounded-full animate-pulse-urgency" />
        <div className="absolute inset-0 w-3 h-3 bg-red-500/50 rounded-full animate-ping" />
      </div>
      
      <div className="flex items-center gap-3">
        <span className="text-sm font-manrope uppercase tracking-[0.2em] font-bold text-[#D4AF37]">
          Only {spots} Spots Left
        </span>
        <div className="w-24 h-2 bg-white/10 rounded-full overflow-hidden">
          <div 
            className="h-full bg-gradient-to-r from-[#D4AF37] to-[#B8860B] rounded-full transition-all duration-500"
            style={{ width: `${percentage}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export const UrgencyBar = () => {
  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-[9998] glass border-t border-white/10 py-3 px-4 md:hidden"
      data-testid="urgency-bar-mobile"
    >
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <div className="relative">
            <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse-urgency" />
          </div>
          <span className="text-xs font-manrope uppercase tracking-wider text-[#D4AF37]">
            {eventInfo.spotsRemaining} spots left
          </span>
        </div>
        <a
          href="#pricing"
          className="bg-[#D4AF37] text-[#0A0A0A] px-4 py-2 rounded-full text-sm font-manrope font-semibold hover:bg-[#B8860B] transition-colors"
          data-testid="urgency-cta-mobile"
        >
          Register Now
        </a>
      </div>
    </div>
  );
};
